import { RoutePath } from '../types/route';

export const EXTERNAL_ROUTE_PROPS = {
  rel: 'noopener noreferrer',
  target: '_blank',
};

export const isRoutePath = (value: string): value is RoutePath => {
  return Object.values(RoutePath).includes(value as RoutePath);
};

export const isExternalRoute = (href: string): boolean => {
  return /^(http:|https:|mailto:|tel:)/.test(href);
};

export const navigateExternalRoute = (href: string) => {
  window.open(href, EXTERNAL_ROUTE_PROPS.target, EXTERNAL_ROUTE_PROPS.rel);
};

export const isCommunicationRoute = (href: string): boolean => {
  return /^(mailto:|tel:)/.test(href);
};

export const isInternalRoute = (href: string): boolean => {
  return Object.values(RoutePath).includes(href as RoutePath);
};
